import EnhancedModal from "../../../components/enhanced-modal";
import {MARGIN_MD, MODAL_WIDTH_LG} from "../../../styles/constants";
import {Button} from "antd";
import React from "react";
import {compose} from "redux";
import {translate} from "react-i18next";
import {connect} from "react-redux";
import ArtefactSummary from "../../../components/artefact-summary";
import {
  changeDsdDetailNotDisplayedCodesSelectorTempSelectedCodes,
  hideDsdDetailNotDisplayedCodesSelector,
  readDsdDetailItemsPageForNotDisplayedCodesSelector,
  submitDsdDetailNotDisplayedCodesSelector
} from "../actions";
import {reuseAction} from "../../../utils/reduxReuse";
import ItemList from "../../../components/item-list";
import {DataLanguageConsumer} from "../../../contexts/DataLanguage";

const mapStateToProps = (state, {instanceState}) => ({
  codelistTriplet: instanceState.codelistTripletForCodesSelector,
  itemsPage: instanceState.itemsPageForNotDisplayedCodesSelector,
  itemsCount: instanceState.itemsCountForNotDisplayedCodesSelector,
  appLanguage: state.app.language,
  tempSelectedCodes: instanceState.tempSelectedCodesForNotDisplayedCodesSelector
});

const mapDispatchToProps = (dispatch, {instancePrefix}) => ({
  onHide: () => dispatch(reuseAction(hideDsdDetailNotDisplayedCodesSelector(), instancePrefix)),
  onSubmit: () => dispatch(reuseAction(submitDsdDetailNotDisplayedCodesSelector(), instancePrefix)),
  fetchItemsPage: ({
                     codelistTriplet,
                     language,
                     pageNum,
                     pageSize,
                     searchText,
                     filters,
                     sortCol,
                     sortByDesc
                   }) => dispatch(reuseAction(readDsdDetailItemsPageForNotDisplayedCodesSelector({
    codelistTriplet,
    language,
    pageNum,
    pageSize,
    searchText,
    filters,
    sortCol,
    sortByDesc
  }), instancePrefix)),
  onChangeTempSelectedCodes: selected =>
    dispatch(reuseAction(changeDsdDetailNotDisplayedCodesSelectorTempSelectedCodes(selected), instancePrefix))
});

const DsdsNotDisplayedCodesSelector = ({
                                         t,
                                         appLanguage,
                                         codelistTriplet,
                                         tempSelectedCodes,
                                         itemsPage,
                                         itemsCount,
                                         onHide,
                                         onSubmit,
                                         fetchItemsPage,
                                         onChangeTempSelectedCodes
                                       }) =>
  <EnhancedModal
    visible={codelistTriplet !== null && tempSelectedCodes !== null}
    width={MODAL_WIDTH_LG}
    title={t('reduxComponents.dsdDetail.notDisplayedCodesSelector.title')}
    onCancel={onHide}
    footer={
      <div>
        <Button onClick={onHide}>
          {t('commons.buttons.cancel.title')}
        </Button>
        <Button onClick={onSubmit} type="primary">
          {t('commons.buttons.save.title')}
        </Button>
      </div>
    }
    withDataLanguageSelector
  >
    <div style={{marginBottom: MARGIN_MD}}>
      <ArtefactSummary
        id={codelistTriplet && codelistTriplet.id}
        agencyID={codelistTriplet && codelistTriplet.agencyID}
        version={codelistTriplet && codelistTriplet.version}
      />
    </div>
    {codelistTriplet !== null && (
      <DataLanguageConsumer>
        {dataLanguage => {
          const language = dataLanguage || appLanguage;
          return (
            <ItemList
              data={itemsPage || null}
              rowCount={itemsCount}
              isPaginated
              onChange={
                ({pageNum, pageSize, searchText, filters, sortCol, sortByDesc}) =>
                  fetchItemsPage({
                    codelistTriplet,
                    language,
                    pageNum,
                    pageSize,
                    searchText,
                    filters,
                    sortCol,
                    sortByDesc
                  })
              }
              rowSelection={{
                selectedRowKeys: tempSelectedCodes,
                onChange: onChangeTempSelectedCodes
              }}
            />
          );
        }}
      </DataLanguageConsumer>
    )}
  </EnhancedModal>;


export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps)
)(DsdsNotDisplayedCodesSelector);
